var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.states,"filter":_vm.customFilter,"item-text":"name","label":"State"}})}
var staticRenderFns = []

export { render, staticRenderFns }